import { type } from '../../utils/index.js';
var num2rgb = function num2rgb(num) {
  if (type(num) == 'number' && num >= 0 && num <= 0xffffff) {
    var r = num >> 16;
    var g = num >> 8 & 0xff;
    var b = num & 0xff;
    return [r, g, b, 1];
  }
  throw new Error('unknown num color: ' + num);
};
export default num2rgb;